module.exports = __webpack_public_path__ + "img/26.78b65a1e.png";